namespace Areas.Account.Schedule {
    "use strict";

    let accountScheduleId: number;
    let accountId: number;
    const baseUrl = "/Account/Schedule";

    export function onCellPrepared(e: any) {
        if (e.rowType !== "data") {
            return;
        }
        setRowBackground(e);
    }

    export function onAccountScheduleGridReady(e: any) {
        accountId = e.component.option("AccountId") as number;
    }

    function setRowBackground(e: any) {
        accountScheduleId = e.component.option("AccountScheduleId") as number;

        if (e.data.accountScheduleId === accountScheduleId) {
            e.cellElement.css("background-color", "#FFA07A");

            const rowData: any = e.data;
            const rowForm: any = Areas.getForm("AccountScheduleForm");
            rowForm.option("formData", rowData);
            Areas.enableButton("SaveAccountSchedule");
            Areas.getGrid("AccountScheduleDetailGrid").option("disabled", false);
        }
    }

    export function viewLink(cellElement: any, cellInfo: any) {
        const action = location.href.toLowerCase().indexOf("edit") > 0 ? "Edit": "View";
        const ids = cellInfo.data.accountId + "/" + cellInfo.data.accountScheduleId;

        buildCellContent(cellElement,
            () => { return ids; },
            `<a href= '${baseUrl}/${action}/{placeholder}'>${action}</a>`);
    }

    export function onNewAccountSchedule(e: any) {
        e.data.accountId = e.component.option("AccountId");
    }

    export function refreshGantt() {
        const gantt: DevExpress.ui.dxGantt = $("#gantt").dxGantt("instance");

        if (gantt) {
            const url = `${baseUrl}/GetScheduleDetailData/${accountScheduleId}`;

            $.get(url, (data) => { 
                gantt.option("tasks")["dataSource"] = data;
                gantt.repaint();
            });
        }
    }

    export function addAccountSchedule() {
        const form = Areas.getForm("AccountScheduleForm");
        const projectCCNumber = form.option("ProjectCCNumber");
        const accountName = form.option("AccountName");

        const data = {
            accountScheduleId: 0,
            accountId: accountId,
            projectCCNumber: projectCCNumber,
            accountName: accountName,
            accountScheduleTypeLk: null,
            accountScheduleName: null,
            accountScheduleStatus: null,
            showOnMaster: false
        }

        form.option("formData", data);
        Areas.getGrid("AccountScheduleDetailGrid").option("disabled", true);
        Areas.disableButton("AddAccountSchedule");
        Areas.enableButton("SaveAccountSchedule");
    }

    export function copySchedule() {
        const url = `${baseUrl}/CopyAccountSchedule/${accountId}/${accountScheduleId}`;
        sendRequest(url, "", "POST");
    }

    export function copySubPhase() {
        const dataGrid = Areas.getGrid("AccountScheduleDetailGrid");
        const selectedRows = dataGrid.getSelectedRowsData();

        if (selectedRows[0] == null) {
            DevExpress.ui.notify("Please make a selection first!", "warning", 2000);
        } else {
            if (selectedRows[0].accountScheduleDetailId == 0) {
                DevExpress.ui.notify("This Record may not be copied (no detailId)", "warning", 2000);
            } else {
                const id = selectedRows[0].accountScheduleDetailId;
                const url = `${baseUrl}/CopySubPhase/${id}`;

                sendRequest(url,
                    "",
                    "POST",
                    () => {
                        dataGrid.refresh();
                        dataGrid.selectRowsByIndexes([0]);
                    });
            }
        }
    }
    
    export function updateAccountSchedule() {
        const newData: any = Areas.getOptionFromForm("AccountScheduleForm", "formData");

        if (newData.accountScheduleId == 0) {
            saveRecord(newData);
        } else {
            updateRecord(newData)
        }
    }

    function saveRecord(data: any) {
        sendRequest(`${baseUrl}/Post/${accountId}`, JSON.stringify(data), "POST");
    }

    function updateRecord(data: any) {
        sendRequest(`${baseUrl}/Put/${accountScheduleId}`, JSON.stringify(data), "PUT", () => { Areas.reloadPage(); });
    }
}